import {
  IPerformerData,
  IPerformerDataActiveEvents,
  IPerformerDataActiveTypeticketcollections,
  IPerformerMetadata,
} from 'meta/pages/v4/performer'
import { useAppSelector } from 'store'
import { PerformerSelectors } from 'store/pages/performer'

export const usePerformerDetails = ({ id, language }: { id: string; language: string }): IPerformerData | undefined =>
  useAppSelector(PerformerSelectors.getPerformerDetails({ id, language }))

export const usePerformerBulkDetails = ({
  codes,
  language,
}: {
  codes: string[]
  language: string
}): IPerformerData[] | undefined => useAppSelector(PerformerSelectors.getPerformerBulkDetails({ codes, language }))

export const usePerformerActiveEvents = ({
  id,
  language,
}: {
  id: string
  language: string
}):
  | {
      data: Record<number, IPerformerDataActiveEvents>
      metadata: IPerformerMetadata
    }
  | undefined => useAppSelector(PerformerSelectors.getPerformerActiveEvents({ id, language }))

export const usePerformerActiveTypeticketcollections = ({
  id,
  language,
}: {
  id: string
  language: string
}):
  | {
      data: Record<number, IPerformerDataActiveTypeticketcollections>
      metadata: IPerformerMetadata
    }
  | undefined => useAppSelector(PerformerSelectors.getPerformerActiveTypeticketcollections({ id, language }))

export const usePerformerMetadata = ({ id, language }: { id: string; language: string }): object | undefined =>
  useAppSelector(PerformerSelectors.getPerformerMetadata({ id, language }))
